import z from 'zod';

import { deliverablesQuerySchema } from '@/_pages/agreements/shared/deliverables';

export const invoiceBatchItemsSchema = z.object({
  client: z.object({
    account_number: z.number(),
    id: z.number(),
    logo: z.array(
      z.object({
        id: z.number(),
        name: z.string(),
        url: z.string(),
      })
    ),
    name: z.string(),
  }),
  sets: z.array(
    z.object({
      type: z.string(),
      total: z.number(),
      remaining: z.number(),
      due: z.number(),
      due_date: z.string(),
      invoice_date: z.string(),
      period_end: z.string(),
      period_start: z.string(),

      agreements: z.array(
        z.object({
          is_selected: z.boolean().nullable(),
          id: z.number(),
          agreement_id: z.string(),
          client_id: z.number(),
          brand_id: z.number().nullable(),
          partner_id: z.number().nullable(),
          execution_date: z.string().nullable(),
          implementation_start_date: z.string().nullable(),
          monthly_recurring_start_date: z.string().nullable(),
          monthly_recurring_stop_date: z.string().nullable(),
          annual_recurring_start_date: z.string().nullable(),
          annual_recurring_stop_date: z.string().nullable(),
          orphan_invoicing: z.boolean().nullable(),
          brand: z
            .object({
              id: z.number(),
              name: z.string(),
            })
            .nullable(),
          one_time_total: z.number(),
          monthly_total: z.number(),
          annual_total: z.number(),
          charge_type: z.string(),
          total: z.number(),
          remaining: z.number(),
          due: z.number(),
          agreement_deliverables: z.array(
            deliverablesQuerySchema
              .pick({
                id: true,
                sku: true,
                quantity: true,
                price: true,
                price_frequency_id: true,
                price_frequency: true,
              })
              .extend({
                name: z.string(),
              })
          ),
        })
      ),
    })
  ),
});

export type InvoiceBatchItemsSchema = z.infer<typeof invoiceBatchItemsSchema>;
